/* ==========================================================================
   HUMO BARRILES · SECCIÓN 1 · MOTOR
   Intro en órbita + salida guiada por el scroll + reacción al mouse.

   Depende de:
     window.THREE      (three.js r128)
     window.gsap       (gsap 3)
     window.ScrollTrigger
   ========================================================================== */
(function () {
  'use strict';

  /* ======================================================================
     0. CONFIGURACIÓN · TODO LO AJUSTABLE VIVE AQUÍ
     ====================================================================== */
  var CONFIG = {

    /* ---- Vista inicial: cerca del planeta, con el sol saliendo detrás ----
       radioFrac = radio del planeta medido en alturas de pantalla.
       x, y = centro del planeta. 0 es el borde izquierdo o superior.        */
    intro: {
      /* El logo y el sol van centrados. El centro vertical del planeta se
         calcula para que el filo pase justo por ese punto, en cualquier
         pantalla. Solo se fija el desplazamiento lateral y el radio.      */
      escritorio: { x: 0.24, radioFrac: 1.55 },
      movil:      { x: 0.24, radioFrac: 1.22 },
      sol:        { x: 0.50, y: 0.50 },     // centro exacto de la pantalla
      solMovil:   { x: 0.50, y: 0.46 },
      aparicion:  1.20,                     // fundido de entrada al cargar
      giro:       0.055                     // rotación durante toda la escena
    },

    /* ---- Posición final del planeta ----
       alturaFrac = porción de la altura visible que ocupa el diámetro.
       Si la cambias, ajusta --hb-planeta-col en el CSS.                     */
    planeta: {
      escritorio: { x: -0.03, y: 0.50, alturaFrac: 0.73 },
      movil:      { x: 0.08, y: 0.11, alturaFrac: 0.30 },
      inclinacion: 0.36,
      nubes: true,
      giroNubes: 1.30
    },

    /* ---- Dirección de la luz del sol ----
       La intro es a contraluz: se ve la media luna y las luces nocturnas.
       Al final la luz viene de la derecha para que el planeta se lea.       */
    sol: {
      intro: { x: 0.86, y: 0.18, z: -0.30 },   // derecha, algo por detrás
      final: { x: 0.78, y: 0.26, z: 0.57 }
    },

    /* ---- Recorrido del scroll ----
       Cada valor va de 0 a 1 sobre el largo total definido en --hb-recorrido */
    guion: {
      zoom:      [0.00, 0.44],
      luz:       [0.04, 0.46],
      solIntro:  [0.00, 0.28],
      estrellas: [0.10, 0.36],
      rasgadoA:  [0.30, 0.46],   // panel derecho
      rasgadoB:  [0.35, 0.51],   // esquina superior
      rasgadoC:  [0.39, 0.55],   // esquina inferior
      marca:     [0.46, 0.58],
      titulo1:   [0.48, 0.63],
      titulo2:   [0.53, 0.69],
      titulo3:   [0.58, 0.75],
      /* la bandera entra en tres golpes, uno por fase de scroll */
      banderaA:  [0.600, 0.660],   // azul con estrellas
      banderaB:  [0.655, 0.715],   // rojo superior izquierdo
      banderaC:  [0.710, 0.770],   // rojo inferior
      banderaD:  [0.765, 0.825],   // rojo del lado derecho
      sam:       [0.813, 0.895],   // arranca con el cuarto trazo casi lleno
      sub:       [0.875, 0.945],
      cue:       [0.940, 1.000]
    },
    suavidadScroll: 0.5,    // retardo del scrub. Más alto = más suave

    /* ---- Reacción al mouse ---- */
    mouse: {
      sam:     { x: -30, y: -18, giro: 1.3 },
      papel:   { x:  14, y:  10 },
      copia:   { x: -10, y:  -6 },
      planeta: { x:  -0.05, y: -0.035 },
      suavidad: 0.7
    },

    /* ---- Rendimiento ---- */
    estrellas:         2200,
    estrellasMovil:     800,
    /* ---- Texturas cartográficas del planeta ----
       Mapas satelitales reales. Cada juego se carga según el tamaño de
       pantalla. Para usar otros archivos, cambia solo estas rutas.      */
    texturas: {
      escritorio: {
        dia:     'tierra-dia-4k.webp',
        noche:   'tierra-noche-2k.webp',
        agua:    'tierra-agua-2k.webp',
        relieve: 'tierra-relieve-2k.webp',
        nubes:   'tierra-nubes-2k.webp',
        resaltaFijo: 'resalta-fijo-2k.webp',
        resaltaUsa:  'resalta-usa-2k.webp'
      },
      movil: {
        dia:     'tierra-dia-2k.webp',
        noche:   'tierra-noche-1k.webp',
        agua:    'tierra-agua-1k.webp',
        relieve: 'tierra-relieve-1k.webp',
        nubes:   'tierra-nubes-1k.webp',
        resaltaFijo: 'resalta-fijo-1k.webp',
        resaltaUsa:  'resalta-usa-1k.webp'
      },
      base: ''                 // prefijo de ruta. En Shopify lo pone el liquid
    },
    /* ---- Modo noche ----
       El planeta se ve desde su cara oscura, con luz de luna rasante.
       Colombia, México, Venezuela y Europa quedan resaltadas en amarillo.
       Estados Unidos hace lo mismo, titilando despacio.                */
    noche: {
      activo: false,
      sol:        { intro: { x: -0.58, y: 0.10, z: -0.81 },
                    final: { x: -0.16, y: 0.24, z: -0.96 } },
      luna:       { x: -0.28, y: 0.34, z: 0.90 },   // desde donde mira el usuario
      colorLuna:  0x6E86B4,
      brilloLuna: 0.30,
      brilloLuces: 2.0,     // multiplicador de las luces de ciudad
      resaltado:  1.05,     // fuerza del contorno y la estela amarilla
      titileo:    { minimo: 0.42, maximo: 1.15, periodo: 3.4 }
    },

    relieve:            1.0,   // fuerza del relieve leído del mapa de elevación
    pixelRatioMax:        2,

    /* ---- Puntos de la historia ----
       Reservados para los marcadores y para la ruta del buque a Miami.
       Quedan del lado visible del planeta en la composición final.     */
    ubicaciones: {
      cartagena: { lat: 10.39, lon: -75.51, nombre: 'Cartagena' },
      miami:     { lat: 25.77, lon: -80.19, nombre: 'Miami' }
    }
  };

  /* Giro final de cada pincelazo, en grados. Ajusta aquí la inclinación
     de la bandera sin tocar el CSS. */
  /* ---- Textos ---- */
  var TEXTOS = {
    en: {
      linea1: 'They', linea2: 'stole', linea3: 'our brand',
      sub1: 'Join us and help us take back a',
      sub2: 'Colombian brand.',
      sub3: 'Never again.',
      cue:  'Scroll to read our story',
      alt:  'Earth from orbit, with Colombia and the United States lit in yellow'
    },
    es: {
      linea1: 'Nos', linea2: 'robaron', linea3: 'la marca',
      sub1: 'Únete y ayúdanos a recuperar una',
      sub2: 'marca colombiana.',
      sub3: 'Que no vuelva a suceder.',
      cue:  'Desliza para conocer nuestra historia',
      alt:  'La Tierra desde la órbita, con Colombia y Estados Unidos encendidos en amarillo'
    }
  };

  var IDIOMA_INICIAL = 'en';
  var CLAVE_IDIOMA   = 'hbIdioma';

  /* Las rutas de las texturas se pueden inyectar desde fuera del archivo.
     En Shopify el liquid define window.HUMO_TEXTURAS con los asset_url. */
  if (window.HUMO_TEXTURAS) {
    if (window.HUMO_TEXTURAS.escritorio) CONFIG.texturas.escritorio = window.HUMO_TEXTURAS.escritorio;
    if (window.HUMO_TEXTURAS.movil)      CONFIG.texturas.movil      = window.HUMO_TEXTURAS.movil;
    if (window.HUMO_TEXTURAS.base != null) CONFIG.texturas.base     = window.HUMO_TEXTURAS.base;
  }

  /* ======================================================================
     1. UTILIDADES
     ====================================================================== */
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var seccion = $('#humo-hero');
  if (!seccion) return;
  var escenario = $('.hb-hero__fijo', seccion) || seccion;

  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var consultaMovil   = window.matchMedia('(max-width: 900px), (orientation: portrait) and (max-width: 1024px)');
  var hayHover        = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var esMovil         = consultaMovil.matches;

  /* ======================================================================
     2. IDIOMA
     ====================================================================== */
  function leerIdioma() {
    try {
      var g = window.localStorage.getItem(CLAVE_IDIOMA);
      if (g === 'en' || g === 'es') return g;
    } catch (e) {}
    return IDIOMA_INICIAL;
  }
  function guardarIdioma(v) { try { window.localStorage.setItem(CLAVE_IDIOMA, v); } catch (e) {} }

  var idiomaActual = leerIdioma();

  function aplicarIdioma(lang) {
    var t = TEXTOS[lang] || TEXTOS.en;
    idiomaActual = lang;
    seccion.setAttribute('data-lang', lang);
    seccion.setAttribute('lang', lang);
    $$('[data-hb-t]', seccion).forEach(function (el) {
      var clave = el.getAttribute('data-hb-t');
      if (t[clave] != null) el.textContent = t[clave];
    });
    var lienzo3d = $('.hb-hero__canvas', seccion);
    if (lienzo3d) lienzo3d.setAttribute('aria-label', t.alt);
    $$('.hb-hero__idioma button', seccion).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.lang === lang));
    });
    guardarIdioma(lang);
  }

  $$('.hb-hero__idioma button', seccion).forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.dataset.lang !== idiomaActual) aplicarIdioma(b.dataset.lang);
    });
  });
  aplicarIdioma(idiomaActual);

  var cue = $('.hb-hero__cue', seccion);
  if (cue) {
    cue.addEventListener('click', function (ev) {
      var destinoDom = document.getElementById('historia');
      if (!destinoDom) return;
      ev.preventDefault();
      destinoDom.scrollIntoView({ behavior: menosMovimiento ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ======================================================================
     3. CARGA DE LAS TEXTURAS CARTOGRÁFICAS
     Mapas satelitales reales. No se dibuja geografía por código.
     ====================================================================== */
  function juegoTexturas() {
    return esMovil ? CONFIG.texturas.movil : CONFIG.texturas.escritorio;
  }

  function rutaTextura(archivo) {
    var base = CONFIG.texturas.base || '';
    if (/^(https?:|data:|\/)/.test(archivo)) return archivo;
    return base + archivo;
  }

  function cargarMapa(cargador, archivo, esColor, anisotropia) {
    var t = cargador.load(rutaTextura(archivo));
    t.wrapS = THREE.RepeatWrapping;
    t.wrapT = THREE.ClampToEdgeWrapping;
    t.minFilter = THREE.LinearMipMapLinearFilter;
    t.magFilter = THREE.LinearFilter;
    t.generateMipmaps = true;
    t.anisotropy = anisotropia;
    if (esColor && THREE.sRGBEncoding) t.encoding = THREE.sRGBEncoding;
    return t;
  }

  /* ======================================================================
     4. ESCENA 3D
     ====================================================================== */
  var lienzo3d = $('.hb-hero__canvas', seccion);

  function hayWebGL() {
    if (!window.THREE) return false;
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext &&
        (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }

  var VERT = [
    'varying vec2 vUv; varying vec3 vN; varying vec3 vV;',
    'varying vec3 vL; varying vec3 vT; varying vec3 vB;',
    'void main(){',
    '  vUv = uv;',
    '  vL = normalize(position);',                 /* punto sobre la esfera, sin rotar */
    '  vec3 tl = normalize(cross(vL, vec3(0.001, 1.0, 0.002)));',
    '  vN = normalize(mat3(modelMatrix) * normal);',
    '  vT = normalize(mat3(modelMatrix) * tl);',
    '  vB = normalize(cross(vN, vT));',
    '  vec4 wp = modelMatrix * vec4(position, 1.0);',
    '  vV = normalize(cameraPosition - wp.xyz);',
    '  gl_Position = projectionMatrix * viewMatrix * wp;',
    '}'
  ].join('\n');

  /* superficie: día, terminador suave, luces nocturnas, reflejo y borde */
  var FRAG_TIERRA = [
    'uniform sampler2D uDia, uNoche, uMar, uAlto, uResalta, uUsa;',
    'uniform vec3 uSol, uAtm, uCalido, uLuzCiudad, uLuna, uLunar;',
    'uniform float uRelieve, uTexel, uModoNoche, uResaltaInt, uUsaInt, uLuces;',
    'varying vec2 vUv; varying vec3 vN; varying vec3 vV;',
    'varying vec3 vL; varying vec3 vT; varying vec3 vB;',
    'void main(){',
    '  vec3 N = normalize(vN), V = normalize(vV), L = normalize(uSol);',
    '  vec3 base = texture2D(uDia, vUv).rgb;',
    '  float mar = texture2D(uMar, vUv).r;',       /* blanco = agua */
    '  float suelo = 1.0 - mar;',
    /* relieve leído del mapa de elevación, por diferencias finitas */
    '  float e = uTexel;',
    '  float hx1 = texture2D(uAlto, vUv + vec2(e, 0.0)).r;',
    '  float hx0 = texture2D(uAlto, vUv - vec2(e, 0.0)).r;',
    '  float hy1 = texture2D(uAlto, vUv + vec2(0.0, e)).r;',
    '  float hy0 = texture2D(uAlto, vUv - vec2(0.0, e)).r;',
    '  float pend = max(0.0001, cos((vUv.y - 0.5) * 3.14159));',  /* corrige la proyección */
    '  vec2 grad = vec2((hx0 - hx1) / pend, hy1 - hy0);',
    '  N = normalize(N + (normalize(vT) * grad.x + normalize(vB) * grad.y) * (12.0 * uRelieve * suelo));',
    '  float d = dot(N, L);',
    '  float dPlano = dot(normalize(vN), L);',     /* terminador limpio, sin relieve */
    '  float dia = smoothstep(-0.14, 0.20, dPlano);',
    /* difusa con caída suave, sin brillo plástico */
    '  vec3 col = base * (0.035 + 1.18 * pow(clamp(d, 0.0, 1.0), 0.92));',
    /* franja cálida del amanecer sobre el terminador */
    '  col += base * uCalido * 0.6 * smoothstep(0.26, 0.0, abs(dPlano)) * dia;',
    /* reflejo del sol solo sobre el agua */
    '  vec3 H = normalize(L + V);',
    '  float esp = pow(max(dot(normalize(vN), H), 0.0), 22.0) * mar * dia;',
    '  col += vec3(1.0, 0.95, 0.86) * esp * 0.3;',
    /* luces de ciudad en la cara nocturna, teñidas con el ámbar de la marca */
    '  float luz = dot(texture2D(uNoche, vUv).rgb, vec3(0.34, 0.5, 0.16));',
    '  luz = smoothstep(0.045, 0.55, luz);',
    '  col += uLuzCiudad * luz * pow(1.0 - dia, 1.5) * 2.4 * uLuces;',
    /* luz de luna: llega desde el lado del espectador y abre la sombra */
    '  float lun = max(dot(normalize(vN), normalize(uLuna)), 0.0);',
    '  col += base * uLunar * pow(lun, 1.15) * uModoNoche;',
    /* países resaltados: contorno fuerte y estela que no opaca el suelo */
    '  float cara = 1.0 - dia;',
    '  vec4 rf = texture2D(uResalta, vUv);',
    '  col += rf.rgb * rf.a * uResaltaInt * (0.22 + 0.95 * cara);',
    '  vec4 ru = texture2D(uUsa, vUv);',
    '  col += ru.rgb * ru.a * uUsaInt * (0.22 + 0.95 * cara);',
    /* filo atmosférico: fino, azul, cálido solo donde entra el sol */
    '  float fres = pow(1.0 - max(dot(normalize(vN), V), 0.0), 4.6);',
    '  vec3 borde = mix(uAtm, uCalido, pow(clamp(dPlano + 0.12, 0.0, 1.0), 2.2));',
    '  col += borde * fres * (0.12 + 0.75 * clamp(dPlano + 0.34, 0.0, 1.0));',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  var FRAG_NUBES = [
    'uniform sampler2D uMapa; uniform vec3 uSol; uniform float uOpacidad;',
    'varying vec2 vUv; varying vec3 vN; varying vec3 vV;',
    'void main(){',
    '  vec3 N = normalize(vN), L = normalize(uSol);',
    '  float d = dot(N, L);',
    '  float dia = smoothstep(-0.16, 0.26, d);',
    '  float a = texture2D(uMapa, vUv).a;',
    '  vec3 col = mix(vec3(0.16,0.19,0.26), vec3(1.0,0.99,0.96), dia);',
    '  col += vec3(1.0,0.72,0.38) * smoothstep(0.3, 0.0, abs(d)) * 0.5;',
    '  gl_FragColor = vec4(col, a * uOpacidad * (0.22 + 0.9 * dia));',
    '}'
  ].join('\n');

  var FRAG_ATM = [
    'uniform vec3 uAtm, uCalido, uSol; uniform float uFuerza;',
    'varying vec3 vN; varying vec3 vV;',
    'void main(){',
    '  vec3 N = normalize(vN), V = normalize(vV), L = normalize(uSol);',
    '  float b = 1.0 - abs(dot(N, V));',
    '  float f = pow(b, 6.5);',                  /* filo delgado, no una nube */
    '  float lado = clamp(dot(N, L) + 0.16, 0.0, 1.0);',
    '  vec3 col = mix(uAtm, uCalido, pow(lado, 2.4));',
    '  gl_FragColor = vec4(col, f * (0.10 + lado * 1.05) * uFuerza);',
    '}'
  ].join('\n');

  function crearEscena() {
    var renderer = new THREE.WebGLRenderer({
      canvas: lienzo3d, antialias: true, alpha: true, powerPreference: 'high-performance'
    });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, CONFIG.pixelRatioMax));
    if (THREE.sRGBEncoding) renderer.outputEncoding = THREE.sRGBEncoding;

    var escena = new THREE.Scene();
    var camara = new THREE.PerspectiveCamera(40, 1, 0.1, 500);
    camara.position.set(0, 0, 10);

    var mapas = juegoTexturas();
    var cargador = new THREE.TextureLoader();
    var aniso = renderer.capabilities.getMaxAnisotropy();

    var tDia     = cargarMapa(cargador, mapas.dia,     true,  aniso);
    var tNoche   = cargarMapa(cargador, mapas.noche,   false, aniso);
    var tMar     = cargarMapa(cargador, mapas.agua,    false, aniso);
    var tAlto    = cargarMapa(cargador, mapas.relieve, false, aniso);
    var tFijo    = cargarMapa(cargador, mapas.resaltaFijo, true, aniso);
    var tUsa     = cargarMapa(cargador, mapas.resaltaUsa,  true, aniso);
    var anchoAlto = esMovil ? 1024 : 2048;   // tamaño del mapa de elevación

    var N = CONFIG.noche;
    var solIni = N.activo ? N.sol.intro : CONFIG.sol.intro;
    var uSol = { value: new THREE.Vector3(solIni.x, solIni.y, solIni.z) };
    var uResaltaInt = { value: N.activo ? N.resaltado : 0 };
    var uUsaInt     = { value: N.activo ? N.resaltado : 0 };
    var uAtm    = { value: new THREE.Color(0x5AA9FF) };
    var uCalido = { value: new THREE.Color(0xFF7A14) };

    var planeta = new THREE.Mesh(
      new THREE.SphereGeometry(1, esMovil ? 96 : 160, esMovil ? 72 : 120),
      new THREE.ShaderMaterial({
        uniforms: {
          uDia: { value: tDia }, uNoche: { value: tNoche },
          uMar: { value: tMar }, uAlto: { value: tAlto },
          uSol: uSol, uAtm: uAtm, uCalido: uCalido,
          uLuzCiudad: { value: new THREE.Color(0xFFB23C) },
          uResalta: { value: tFijo }, uUsa: { value: tUsa },
          uResaltaInt: uResaltaInt, uUsaInt: uUsaInt,
          uLuna:  { value: new THREE.Vector3(N.luna.x, N.luna.y, N.luna.z) },
          uLunar: { value: new THREE.Color(N.colorLuna).multiplyScalar(N.brilloLuna) },
          uModoNoche: { value: N.activo ? 1 : 0 },
          uLuces:     { value: N.activo ? N.brilloLuces : 1 },
          uRelieve: { value: esMovil ? CONFIG.relieve * 0.7 : CONFIG.relieve },
          uTexel:   { value: 1 / anchoAlto }
        },
        vertexShader: VERT, fragmentShader: FRAG_TIERRA
      })
    );
    planeta.rotation.z = CONFIG.planeta.inclinacion;

    var grupo = new THREE.Group();
    grupo.add(planeta);
    escena.add(grupo);

    var nubes = null;
    if (CONFIG.planeta.nubes) {
      var tNubes = cargarMapa(cargador, mapas.nubes, true, aniso);
      nubes = new THREE.Mesh(
        new THREE.SphereGeometry(1.006, esMovil ? 64 : 96, esMovil ? 48 : 72),
        new THREE.ShaderMaterial({
          uniforms: { uMapa: { value: tNubes }, uSol: uSol, uOpacidad: { value: 0.72 } },
          vertexShader: VERT, fragmentShader: FRAG_NUBES,
          transparent: true, depthWrite: false
        })
      );
      nubes.rotation.z = CONFIG.planeta.inclinacion;
      grupo.add(nubes);
    }

    var halo = new THREE.Mesh(
      new THREE.SphereGeometry(1.055, 72, 54),
      new THREE.ShaderMaterial({
        uniforms: { uAtm: uAtm, uCalido: uCalido, uSol: uSol, uFuerza: { value: 1 } },
        vertexShader: VERT, fragmentShader: FRAG_ATM,
        transparent: true, blending: THREE.AdditiveBlending,
        side: THREE.BackSide, depthWrite: false
      })
    );
    grupo.add(halo);

    /* estrellas */
    var total = esMovil ? CONFIG.estrellasMovil : CONFIG.estrellas;
    var pos = new Float32Array(total * 3);
    var tam = new Float32Array(total);
    for (var i = 0; i < total; i++) {
      pos[i * 3]     = (Math.random() - 0.5) * 120;
      pos[i * 3 + 1] = (Math.random() - 0.5) * 80;
      pos[i * 3 + 2] = -Math.random() * 160 - 12;
      tam[i] = Math.random() * 1.7 + 0.3;
    }
    var geoEstrellas = new THREE.BufferGeometry();
    geoEstrellas.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    geoEstrellas.setAttribute('aTam', new THREE.BufferAttribute(tam, 1));

    var estrellas = new THREE.Points(geoEstrellas, new THREE.ShaderMaterial({
      transparent: true, depthWrite: false, blending: THREE.AdditiveBlending,
      uniforms: { uOpacidad: { value: 0 } },
      vertexShader: [
        'attribute float aTam; varying float vA;',
        'void main(){',
        '  vec4 mv = modelViewMatrix * vec4(position,1.0);',
        '  gl_PointSize = aTam * (120.0 / max(-mv.z, 1.0));',
        '  vA = clamp(1.0 - (-mv.z) / 160.0, 0.05, 1.0);',
        '  gl_Position = projectionMatrix * mv;',
        '}'
      ].join('\n'),
      fragmentShader: [
        'uniform float uOpacidad; varying float vA;',
        'void main(){',
        '  vec2 d = gl_PointCoord - vec2(0.5);',
        '  float a = smoothstep(0.5, 0.06, length(d));',
        '  gl_FragColor = vec4(1.0, 0.96, 0.9, a * vA * uOpacidad);',
        '}'
      ].join('\n')
    }));
    escena.add(estrellas);

    return {
      renderer: renderer, escena: escena, camara: camara,
      grupo: grupo, planeta: planeta, nubes: nubes, halo: halo,
      estrellas: estrellas, uSol: uSol,
      uResaltaInt: uResaltaInt, uUsaInt: uUsaInt,
      giro: CONFIG.intro.giro,
      empujeX: 0, empujeY: 0, empujeXd: 0, empujeYd: 0
    };
  }

  /* ---- fracción de pantalla a coordenadas del mundo ---- */
  function ubicar(m, xFrac, yFrac) {
    var d = m.camara.position.z;
    var altoVis  = 2 * Math.tan((m.camara.fov * Math.PI / 180) / 2) * d;
    var anchoVis = altoVis * m.camara.aspect;
    return { x: (xFrac - 0.5) * anchoVis, y: (0.5 - yFrac) * altoVis, altoVis: altoVis };
  }

  function destino()  { return esMovil ? CONFIG.planeta.movil : CONFIG.planeta.escritorio; }
  function puntoSol() { return esMovil ? CONFIG.intro.solMovil : CONFIG.intro.sol; }

  /* La vista de arranque se resuelve con el aspecto real de la pantalla:
     el filo del planeta cruza exactamente por donde está el logo.        */
  function arranque(m) {
    var a = esMovil ? CONFIG.intro.movil : CONFIG.intro.escritorio;
    var s = puntoSol();
    var aspecto = m ? m.camara.aspect : (escenario.clientWidth / escenario.clientHeight);
    var dx = (s.x - a.x) * aspecto;                    // en alturas de pantalla
    var dentro = Math.max(0, a.radioFrac * a.radioFrac - dx * dx);
    return { x: a.x, y: s.y + Math.sqrt(dentro), radioFrac: a.radioFrac };
  }

  /* vista actual del planeta, en fracciones de pantalla */
  var vista = { x: 0, y: 0, radioFrac: 1 };

  function aplicarVista(m) {
    var d = destino();
    var escala = vista.radioFrac / (d.alturaFrac / 2);
    m.grupo.scale.setScalar(escala);
    var p = ubicar(m, vista.x, vista.y);
    m.grupo.position.x = p.x + m.empujeX;
    m.grupo.position.y = p.y + m.empujeY;
  }

  function ajustar(m) {
    var w = escenario.clientWidth, h = escenario.clientHeight;
    if (!w || !h) return;
    m.renderer.setSize(w, h, false);
    m.camara.aspect = w / h;
    var d = destino();
    var altoVis = 2 / d.alturaFrac;
    m.camara.position.z = (altoVis / 2) / Math.tan((m.camara.fov * Math.PI / 180) / 2);
    m.camara.updateProjectionMatrix();
    aplicarVista(m);
    seccion.style.setProperty('--hb-fb-x', (d.x * 100) + '%');
    seccion.style.setProperty('--hb-fb-y', (d.y * 100) + '%');
    var s = puntoSol();
    seccion.style.setProperty('--hb-sol-x', (s.x * 100) + '%');
    seccion.style.setProperty('--hb-sol-y', (s.y * 100) + '%');
  }

  /* ======================================================================
     5. GUION DEL SCROLL
     ====================================================================== */
  function tramo(nombre) {
    var t = CONFIG.guion[nombre];
    return { inicio: t[0], largo: t[1] - t[0] };
  }

  function construirGuion(m) {
    var G = {
      papel:  $('.hb-hero__papel', seccion),
      der:    $('.hb-hero__rasgado--der', seccion),
      sup:    $('.hb-hero__rasgado--sup', seccion),
      inf:    $('.hb-hero__rasgado--inf', seccion),
      intro:  $('.hb-hero__intro', seccion),
      sol:    $('.hb-hero__sol', seccion),
      flare:  $('.hb-hero__flare', seccion),
      rayos:  $('.hb-hero__rayos', seccion),
      sello:  $('.hb-hero__sello', seccion),
      haces:  $('.hb-hero__haces', seccion),
      marca:  $('.hb-hero__marca', seccion),
      idioma: $('.hb-hero__idioma', seccion),
      uno:    $('.hb-hero__linea--uno', seccion),
      dos:    $('.hb-hero__linea--dos', seccion),
      tres:   $('.hb-hero__linea--tres', seccion),
      sub:    $('.hb-hero__sub', seccion),
      cue:    $('.hb-hero__cue', seccion),
      sam:    $('.hb-hero__sam', seccion),
      azul:   $('.hb-hero__pincel--azul', seccion),
      rojo1:  $('.hb-hero__pincel--rojo1', seccion),
      rojo2:  $('.hb-hero__pincel--rojo2', seccion),
      rojo3:  $('.hb-hero__pincel--rojo3', seccion)
    };

    /* estado de partida */
    var a = arranque(m);
    vista.x = a.x; vista.y = a.y; vista.radioFrac = a.radioFrac;
    aplicarVista(m);

    /* GSAP reescribe el transform completo, así que el centrado de las
       piezas de la intro se declara aquí y no solo en el CSS */
    gsap.set([G.sol, G.flare], { xPercent: -50, yPercent: -50 });

    gsap.set([G.der], { opacity: 0, x: 110 });
    gsap.set([G.sup], { opacity: 0, x: -80, y: -56, rotate: -2.5 });
    gsap.set([G.inf], { opacity: 0, x: -80, y: 56, rotate: 2.5 });
    gsap.set(G.marca,  { opacity: 0, y: 18 });
    gsap.set(G.idioma, { opacity: 0 });
    gsap.set(G.uno,  { opacity: 0, x: 48,  filter: 'blur(18px)' });
    gsap.set(G.dos,  { opacity: 0, x: 80,  filter: 'blur(18px)', scale: 1.07 });
    gsap.set(G.tres, { opacity: 0, x: 104, filter: 'blur(26px)', scale: 1.1 });
    gsap.set(G.sub,  { opacity: 0, y: 26 });
    gsap.set(G.cue,  { opacity: 0, y: 14 });
    gsap.set(G.sam,  { opacity: 0, x: 35, scale: 0.94 });

    /* pincelazos: fuera de cuadro, encogidos y sin revelar */
    /* cada trazo se queda en su posición final: solo se revela */
    gsap.set([G.azul, G.rojo1, G.rojo2, G.rojo3].filter(Boolean),
      { opacity: 0, filter: 'blur(5px)', '--hb-rev': '-18%' });

    /* aparición al cargar: no depende del scroll */
    gsap.to(G.intro, { opacity: 1, duration: CONFIG.intro.aparicion, ease: 'power2.out', delay: 0.15 });

    /* el sello entra en el mismo momento en que entraba el logo */
    gsap.fromTo(G.sello,
      { opacity: 0, scale: 0.92, filter: 'blur(6px)' },
      { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1.0, ease: 'power2.out', delay: 0.15 });

    /* los haces asoman poco después */
    gsap.to(G.haces, { opacity: 1, duration: 1.6, ease: 'power1.out', delay: 0.85 });
    gsap.to(m.estrellas.material.uniforms.uOpacidad,
      { value: 1, duration: CONFIG.intro.aparicion + 0.4, ease: 'power2.out' });

    var tl = gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: seccion,
        start: 'top top',
        end: 'bottom bottom',
        scrub: CONFIG.suavidadScroll,
        /* el will-change solo vive mientras la secuencia corre */
        onUpdate: function (self) {
          var activo = self.progress > 0.001 && self.progress < 0.999;
          seccion.setAttribute('data-corriendo', activo ? 'si' : 'no');
        }
      }
    });

    var d = destino(), t;

    /* alejamiento: el planeta viaja a su posición final */
    t = tramo('zoom');
    tl.to(vista, {
      x: d.x, y: d.y, radioFrac: d.alturaFrac / 2,
      duration: t.largo, ease: 'power2.inOut',
      onUpdate: function () { aplicarVista(m); }
    }, t.inicio);

    /* la luz gira: el terminador se desplaza sobre el planeta */
    t = tramo('luz');
    var solFin = CONFIG.noche.activo ? CONFIG.noche.sol.final : CONFIG.sol.final;
    tl.to(m.uSol.value, {
      x: solFin.x, y: solFin.y, z: solFin.z,
      duration: t.largo, ease: 'power1.inOut'
    }, t.inicio);

    /* el sol y el logo de la intro se retiran */
    t = tramo('solIntro');
    tl.to(G.sol,       { opacity: 0, scale: 0.42, duration: t.largo, ease: 'power2.in' }, t.inicio)
      .to(G.flare,     { opacity: 0, scale: 0.55, duration: t.largo, ease: 'power2.in' }, t.inicio)
      .to(G.rayos,     { opacity: 0, duration: t.largo * 0.7, ease: 'power2.in' }, t.inicio)
      .to(G.haces,     { opacity: 0, duration: t.largo * 0.6, ease: 'power2.in' }, t.inicio)
      .to(G.sello,     { opacity: 0, y: -34, scale: 0.72, duration: t.largo * 0.8, ease: 'power2.in' }, t.inicio);

    t = tramo('estrellas');
    tl.to(m.estrellas.material.uniforms.uOpacidad, { value: 0.5, duration: t.largo }, t.inicio);

    /* papel rasgado, una pieza tras otra */
    t = tramo('rasgadoA');
    tl.to(G.der, { opacity: 1, x: 0, duration: t.largo, ease: 'power3.out' }, t.inicio);
    t = tramo('rasgadoB');
    tl.to(G.sup, { opacity: 1, x: 0, y: 0, rotate: 0, duration: t.largo, ease: 'power3.out' }, t.inicio);
    t = tramo('rasgadoC');
    tl.to(G.inf, { opacity: 1, x: 0, y: 0, rotate: 0, duration: t.largo, ease: 'power3.out' }, t.inicio);

    /* marca */
    t = tramo('marca');
    tl.to(G.marca,  { opacity: 1, y: 0, duration: t.largo, ease: 'power2.out' }, t.inicio)
      .to(G.idioma, { opacity: 1, duration: t.largo * 0.7, ease: 'power2.out' }, t.inicio);

    /* titular en tres golpes */
    t = tramo('titulo1');
    tl.to(G.uno,  { opacity: 1, x: 0, filter: 'blur(0px)', duration: t.largo, ease: 'power3.out' }, t.inicio);
    t = tramo('titulo2');
    tl.to(G.dos,  { opacity: 1, x: 0, filter: 'blur(0px)', scale: 1, duration: t.largo, ease: 'power4.out' }, t.inicio);
    t = tramo('titulo3');
    tl.to(G.tres, { opacity: 1, x: 0, filter: 'blur(0px)', scale: 1, duration: t.largo, ease: 'power4.out' }, t.inicio);

    /* bandera: tres pinceladas, una por fase */
    var pincelada = function (el, clave) {
      if (!el) return;
      var f = tramo(clave);
      tl.to(el, {
        opacity: 1, filter: 'blur(0px)', '--hb-rev': '118%',
        duration: f.largo, ease: 'power2.out'
      }, f.inicio);
    };
    pincelada(G.azul,  'banderaA');
    pincelada(G.rojo1, 'banderaB');
    pincelada(G.rojo2, 'banderaC');
    pincelada(G.rojo3, 'banderaD');   // cuarto trazo, cuando exista el archivo

    /* tío Sam, con traslape sobre el último trazo */
    t = tramo('sam');
    tl.to(G.sam, {
      opacity: 1, x: 0, scale: 1,
      duration: t.largo, ease: 'power3.out'
    }, t.inicio);

    t = tramo('sub');
    tl.to(G.sub, { opacity: 1, y: 0, duration: t.largo, ease: 'power2.out' }, t.inicio);
    t = tramo('cue');
    tl.to(G.cue, { opacity: 1, y: 0, duration: t.largo, ease: 'power2.out' }, t.inicio);

    return { tl: tl, G: G };
  }

  /* ---- estado final sin animación ---- */
  function estadoFinal(m) {
    var d = destino();
    vista.x = d.x; vista.y = d.y; vista.radioFrac = d.alturaFrac / 2;
    aplicarVista(m);
    var sf = CONFIG.noche.activo ? CONFIG.noche.sol.final : CONFIG.sol.final;
    m.uSol.value.set(sf.x, sf.y, sf.z);
    m.estrellas.material.uniforms.uOpacidad.value = 0.5;
    $$('.hb-hero__rasgado, .hb-hero__pincel, .hb-hero__sello, .hb-hero__marca, .hb-hero__linea, .hb-hero__sub, .hb-hero__cue, .hb-hero__idioma, .hb-hero__sam', seccion)
      .forEach(function (el) {
        el.style.opacity = 1; el.style.transform = 'none'; el.style.filter = 'none';
        el.style.setProperty('--hb-rev', '120%');
      });
  }

  /* ======================================================================
     6. REACCIÓN AL MOUSE
     ====================================================================== */
  function conectarMouse(m, G) {
    if (!hayHover || menosMovimiento) return;
    var M = CONFIG.mouse;
    var opc = { duration: M.suavidad, ease: 'power3' };

    var samX = gsap.quickTo('.hb-hero__sam-cap', 'x', opc);
    var samY = gsap.quickTo('.hb-hero__sam-cap', 'y', opc);
    var samR = gsap.quickTo('.hb-hero__sam-cap', 'rotation', opc);
    var papX = gsap.quickTo('.hb-hero__papel', 'x', opc);
    var papY = gsap.quickTo('.hb-hero__papel', 'y', opc);
    var copX = gsap.quickTo('.hb-hero__copia-cap', 'x', opc);
    var copY = gsap.quickTo('.hb-hero__copia-cap', 'y', opc);

    window.addEventListener('mousemove', function (ev) {
      var r = escenario.getBoundingClientRect();
      var mx = (ev.clientX - r.left) / r.width  - 0.5;   // -0.5 a 0.5
      var my = (ev.clientY - r.top)  / r.height - 0.5;
      mx = Math.max(-0.5, Math.min(0.5, mx));
      my = Math.max(-0.5, Math.min(0.5, my));

      samX(mx * M.sam.x * 2); samY(my * M.sam.y * 2); samR(mx * M.sam.giro);
      papX(mx * M.papel.x * 2); papY(my * M.papel.y * 2);
      copX(mx * M.copia.x * 2); copY(my * M.copia.y * 2);

      m.empujeXd = mx * M.planeta.x * 2;
      m.empujeYd = my * M.planeta.y * 2;
    }, { passive: true });
  }

  /* ======================================================================
     7. ARRANQUE
     ====================================================================== */
  if (!hayWebGL() || !window.gsap) {
    seccion.setAttribute('data-webgl', 'no');
    $$('.hb-hero__rasgado, .hb-hero__pincel, .hb-hero__sello, .hb-hero__marca, .hb-hero__linea, .hb-hero__sub, .hb-hero__cue, .hb-hero__idioma, .hb-hero__sam', seccion)
      .forEach(function (el) { el.style.opacity = 1; });
    return;
  }

  var motor = crearEscena();
  ajustar(motor);
  seccion.setAttribute('data-noche', CONFIG.noche.activo ? 'si' : 'no');

  var reloj = new THREE.Clock();
  var visible = true;
  var pulso = 0;

  function cuadro() {
    var dt = Math.min(reloj.getDelta(), 0.05);
    if (visible) {
      /* titileo suave de Estados Unidos: dos ondas de distinto periodo
         para que la respiración no se sienta mecánica */
      if (CONFIG.noche.activo) {
        var T = CONFIG.noche.titileo;
        pulso += dt;
        var onda = 0.5 + 0.5 * Math.sin(pulso * (6.2832 / T.periodo));
        var onda2 = 0.5 + 0.5 * Math.sin(pulso * (6.2832 / (T.periodo * 1.7)) + 1.1);
        var mezcla = onda * 0.68 + onda2 * 0.32;
        motor.uUsaInt.value = T.minimo + (T.maximo - T.minimo) * mezcla;
      }
      motor.planeta.rotation.y += motor.giro * dt;
      if (motor.nubes) motor.nubes.rotation.y += motor.giro * CONFIG.planeta.giroNubes * dt;
      /* el empuje del mouse se acerca poco a poco a su objetivo */
      motor.empujeX += (motor.empujeXd - motor.empujeX) * Math.min(1, dt * 4);
      motor.empujeY += (motor.empujeYd - motor.empujeY) * Math.min(1, dt * 4);
      aplicarVista(motor);
      motor.renderer.render(motor.escena, motor.camara);
    }
    requestAnimationFrame(cuadro);
  }
  requestAnimationFrame(cuadro);

  var guion = null;
  if (menosMovimiento || !window.ScrollTrigger) {
    estadoFinal(motor);
  } else {
    gsap.registerPlugin(ScrollTrigger);
    guion = construirGuion(motor);
    conectarMouse(motor, guion.G);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0 }).observe(seccion);
  }

  /* con la pestaña oculta se paran el dibujado y las animaciones de CSS */
  document.addEventListener('visibilitychange', function () {
    var oculta = document.hidden;
    seccion.setAttribute('data-pausa', oculta ? 'si' : 'no');
    if (!oculta) reloj.getDelta();
  });

  var tempo = null;
  /* ======================================================================
     8. API PÚBLICA
     Para los marcadores de Cartagena y Miami y para la ruta del buque.
     ====================================================================== */
  window.HUMO_HERO = {
    config: CONFIG,
    ubicaciones: CONFIG.ubicaciones,
    escena: motor.escena,
    grupo: motor.grupo,
    planeta: motor.planeta,
    camara: motor.camara,
    renderer: motor.renderer,

    /* punto de la superficie en el espacio local del planeta.
       altura 0 es el suelo, 0.04 flota un poco sobre él. */
    puntoEsfera: function (lat, lon, altura) {
      var r = 1 + (altura || 0);
      var phi   = ((lon + 180) / 360) * Math.PI * 2;
      var theta = ((90 - lat) / 180) * Math.PI;
      return new THREE.Vector3(
        -r * Math.cos(phi) * Math.sin(theta),
         r * Math.cos(theta),
         r * Math.sin(phi) * Math.sin(theta)
      );
    },

    /* gira el planeta para que ese punto quede de frente a la cámara */
    mirarA: function (lat, lon) {
      var p = window.HUMO_HERO.puntoEsfera(lat, lon, 0);
      motor.planeta.rotation.y = Math.atan2(p.z, p.x) - Math.PI / 2;
      if (motor.nubes) motor.nubes.rotation.y = motor.planeta.rotation.y;
    },

    /* detiene o reanuda la rotación, útil mientras zarpa el buque */
    girar: function (velocidad) { motor.giro = velocidad; },

    /* enciende o apaga el modo noche en caliente */
    noche: function (encendido) {
      var N = CONFIG.noche;
      N.activo = !!encendido;
      var u = motor.planeta.material.uniforms;
      u.uModoNoche.value = N.activo ? 1 : 0;
      u.uLuces.value     = N.activo ? N.brilloLuces : 1;
      motor.uResaltaInt.value = N.activo ? N.resaltado : 0;
      motor.uUsaInt.value     = N.activo ? N.resaltado : 0;
      var s = N.activo ? N.sol.final : CONFIG.sol.final;
      motor.uSol.value.set(s.x, s.y, s.z);
      seccion.setAttribute('data-noche', N.activo ? 'si' : 'no');
    }
  };

  window.addEventListener('resize', function () {
    clearTimeout(tempo);
    tempo = setTimeout(function () {
      esMovil = consultaMovil.matches;
      ajustar(motor);
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    }, 140);
  }, { passive: true });

})();
